<template>
  <div class='dress_content'>
    <div v-if="mod!=='Calendar'" class='radius_bg' style='padding-bottom: 10px'>
      <el-form :model='searchCondition' inline size='mini' @submit.native.prevent>
        <el-form-item label=''>
          <el-input placeholder='产品名称' v-model='searchCondition.title' @change='handleQuery' clearable />
        </el-form-item>
        <el-form-item>
          <el-input placeholder='品牌' v-model='searchCondition.brand_name' @change='handleQuery' clearable
                    style='width: 200px;' />
        </el-form-item>
        <el-form-item>
          <ProductLeaderSelect ref='refProductLeader' :leader-id.sync='searchCondition.leader_id'
                               leader-type='product-dress' @selected='handleQuery'
                               v-if="canViewAll" />
          <span v-else>{{ userInfo.nickname }} </span>
        </el-form-item>
        <el-form-item>
          <el-select @change='handleQuery' clearable placeholder='请选择是否标品'
                     v-model='searchCondition.wares_standard_is'>
            <el-option v-for='item in standardOption' :key='item.value' :label='item.label' :value='item.value'>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model='modePrice' style='width: 100px;margin-right: 2px' placeholder=''>
            <el-option key='price' label='日常价' value='price'></el-option>
            <el-option key='lb_price' label='直播价' value='lb_price'></el-option>
          </el-select>
          <el-input placeholder='最低价' style='width: 100px' v-model='price[0]' clearable />
          ~
          <el-input placeholder='最高价' style='width: 100px' v-model='price[1]' clearable />
        </el-form-item>
        <el-form-item label=''>
          <el-select @change='handleQuery' clearable v-model='searchCondition.used_season' placeholder='季节性'
                     style='width: 100px'>
            <el-option label='春' value='春'></el-option>
            <el-option label='夏' value='夏'></el-option>
            <el-option label='秋' value='秋'></el-option>
            <el-option label='冬' value='冬'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type='primary' icon='el-icon-search' @click='handleQuery'>搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click='reset'>重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div v-else class='floating-search-btn' @click='searchDialogVisible = true'>
      <el-button type='primary' circle size='medium' class='search-icon-btn'>
        <i class='el-icon-search'></i>
      </el-button>
    </div>

    <DressSearchForm
      :visible.sync='searchDialogVisible'
      :search-condition='searchCondition'
      :mode-price='modePrice'
      :price='price'
      :standard-option='standardOption'
      @confirm='handleSearchConfirm'
      @reset='handleSearchReset'
      @update:modePrice='val => modePrice = val'
      @update:price='val => price = val'
      @leader-selected='selectedLeader'
    />
    <product-dress-store ref='store' @success='getList' />
    <init-loading :isInitLoading.sync='isInitLoading'></init-loading>

    <!--      卡片-->
    <div class='radius_bg'>
      <div class='button-toolbar'>

        <el-row :gutter='10' class='mb8 button-row'>
          <el-col :span='1.5'>
            <el-button type='primary' icon='el-icon-plus' @click='handleDressStore(false)'
                       v-if="canCreate">添加
            </el-button>
          </el-col>
          <el-col :span='1.5'>
            <el-button v-if="canHandOver" type='warning'
                       icon='el-icon-connection' @click='toHandover'>交接
            </el-button>
          </el-col>
          <el-col :span='1.5'>
            <el-button icon='el-icon-upload' v-if="canImport"
                       @click='openImport = true'>
              导入
            </el-button>
          </el-col>
          <el-button icon='el-icon-setting' v-if="mod === 'Table'" @click='customColumnShow = true'>列设置
          </el-button>
          <el-col :span='1.5'>
            <export-btn :can-export='canExport' :lint-title='`导出表格`'
                        @export='downExcel' ref='refExportLink'></export-btn>
          </el-col>

          <el-col :span='1.5'>
            <el-button v-if='canHistoryKol' icon='el-icon-plus'
                       @click='handleAddBtn("kol")'>历史选品会
            </el-button>
          </el-col>
          <el-col :span='1.5'>
            <el-button v-if='canHistoryLive' icon='el-icon-plus'
                       @click='handleAddBtn("live")'>历史直播
            </el-button>
          </el-col>
          <div v-if="mod === 'Table'">
            <el-col :span='1.5' v-if='canTransfer'>
              <el-popover
                placement='right'
                width='200'
                trigger='click'>
                <div>

                  <product-transfer :c-type='1' :get-products='getSelectionProducts' @success='callbackProductTransfer'
                                    style='margin-bottom: 5px' />
                  <br />
                  <product-transfer :c-type='3' :get-products='getSelectionProducts'
                                    @success='callbackProductTransfer' />
                </div>
                <el-button slot='reference' icon='el-icon-d-arrow-right'>转移</el-button>
              </el-popover>
            </el-col>
            <el-col :span='1.5' v-if='canTransfer'>
              <el-popover
                placement='right'
                width='200'
                trigger='click'>
                <div>
                  <product-copy :c-type='1' :get-products='getSelectionProducts' @success='callbackProductTransfer'
                                style='margin-bottom: 5px' />
                  <br />
                  <product-copy :c-type='3' :get-products='getSelectionProducts' @success='callbackProductTransfer' />
                </div>
                <el-button  slot='reference' icon='el-icon-copy-document'>复制</el-button>
              </el-popover>
            </el-col>
            <el-col v-if='canTransfer' :span='1.5'>

              <status-dropdown @success='getList' :get-products='getSelectionProducts'></status-dropdown>
            </el-col>
          </div>
        </el-row>

        <div style='text-align: right'>
          <el-radio-group v-model='mod'>
            <el-radio-button label='Calendar'>卡片(新)</el-radio-button>
            <el-radio-button label='CalendarOld'>卡片(经典)</el-radio-button>
            <el-radio-button label='Table'>列表</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </div>
    <!--          <el-col :span='4' style='text-align: right'>-->
    <!--            <el-radio-group v-model='mod'>-->
    <!--              <el-radio-button label='Calendar'>卡片(新)</el-radio-button>-->
    <!--              <el-radio-button label='CalendarOld'>卡片(旧)</el-radio-button>-->
    <!--              <el-radio-button label='Table'>列表</el-radio-button>-->
    <!--            </el-radio-group>-->
    <!--          </el-col>-->
    <!-- 新卡片 瀑布流-->
    <dress-update-card ref='dressUpdateCard' v-if="mod==='Calendar'" :searchCondition='searchCondition'
                       @handleDetails='handleDetails' @handleDelete='handleDelete'
                       @handleJoinLive='handleJoinLive' @handleEdit='handleDressStore'></dress-update-card>
    <div v-if="mod === 'CalendarOld'" class='radius_bg'>
      <dress-old-card @handleDressStore='handleDressStore' @handleDelete='handleDelete'
                      @handleDetails='handleDetails' @handleJoinLive='handleJoinLive' :dataList='dataList'
                      :loading='loading'></dress-old-card>
    </div>


    <!-- 表格模式 -->
    <dress-library-table
      v-if="mod==='Table'"
      ref="dressTable"
      :dataList="dataList"
      :tableLoading="tableLoading"
      :canEdit="canEdit"
      :canDelete="canDelete"
      @edit="handleDressStore"
      @delete="handleDelete"
    />
    <pagination :hidden='total === 0' :background='true' :total.sync='total' :autoScroll='true'
                v-if="mod !== 'Calendar'" :page.sync='pageData.current_page' :limit.sync='pageData.page_size'
                :page-sizes="[12, 24, 36, 48]" @pagination='getList' />
    <!--    添加组件-->
    <add-dress ref='addDress' @handelStore='handelStore' :visible.sync='open' :id='currentId'
               @close='getList'></add-dress>
    <!--    列设置-->
    <MColumnSetting :visible.sync='customColumnShow' ref='columnSetting' @userChange='columnSettingChange'
                    :column='userColumns' :table-name='tableName' @back='columnSettingBack' @save='columnSettingSave'>
    </MColumnSetting>
    <!--    右键菜单-->
    <!--    <ProductLog :info-id='currId' :visible.sync='openLog'/>-->
    <exportDialog :file-name='`服饰品牌库`' :column='userColumns' :searchCondition='searchCondition'
                  :listApi="'getProductDressList'" :visible.sync='downloadLoading'
                  @close='downloadLoading = false'></exportDialog>
    <JoinLive :productId='productId' :visible.sync='joinliveShow'></JoinLive>
    <!--    历史排期-->
    <!--    historicalDialog-->
    <HistoricalPage :historicalType='HistoricalType' :visible.sync='historicalDialog' @close='getList'></HistoricalPage>
    <!--    导入标品-->
    <ImportProductDress :visible.sync='openImport' @imported='handleQuery' />
    <dress-details :visible.sync='openDetails' :rowDetails='rowDetails' />

    <!-- 悬浮搜索按钮 -->
  </div>
</template>

<script>
import ExportBtn from '@/components/export/ExportBtn'
import { mapGetters } from 'vuex'
import ProductLeaderSelect from '@/pages/lb/components/ProductLeaderSelect'
import AddDress from '@/pages/lb/dress/AddDress.vue'
import MColumnSetting from '@/components/common/MColumnSetting'
import exportDialog from '@/pages/lb/dress/exportDialog.vue'
import JoinLive from '@/pages/lb/dress/JoinLive.vue'
import HistoricalPage from '@/pages/lb/dress/HistoricalPage.vue'
import ImportProductDress from '@/pages/lb/dress/components/ImportProductDress'
import ProductDressStore from '@/pages/lb/dress/store.vue'
import DressOldCard from '@/pages/lb/dress/DressOldCard.vue'
import DressUpdateCard from '@/pages/lb/dress/DressUpdateCard.vue'
import DressDetails from './DressDetails'
import ProductTransfer from '@/pages/lb/product/component/transfer.vue'
import StatusDropdown from '@/pages/lb/dress/components/StatusDropdown.vue'
import DressSearchForm from './components/DressSearchForm.vue'
import ProductCopy from '@/pages/lb/product/component/copy.vue'
import DressLibraryTable from './DressLibraryTable.vue'
import  { omitBy } from 'lodash'

export default {
  name: 'DressDressLibrary',
  components: {
    ProductCopy,
    StatusDropdown,
    ProductTransfer,
    ProductDressStore,
    ImportProductDress,
    AddDress,
    ProductLeaderSelect,
    ExportBtn,
    MColumnSetting,
    exportDialog,
    JoinLive,
    HistoricalPage,
    DressDetails,
    DressOldCard,
    DressUpdateCard,
    DressSearchForm,
    DressLibraryTable
  },
  computed: {
    ...mapGetters(['userPermissions', 'userInfo']),
    canViewAll() { return this.userPermissions.indexOf('product_view_all') > -1 },
    canCreate() { return this.userPermissions.indexOf('product_dress_create') > -1 },
    canHandOver() { return this.userPermissions.indexOf('product_dress_hand_over') > -1 },
    canImport() { return this.userPermissions.indexOf('product_dress_import') > -1 },
    canExport() { return this.userPermissions.indexOf('product_dress_export') > -1 },
    canHistoryKol() { return this.userPermissions.indexOf('product_dress_history_kol') > -1 },
    canHistoryLive() { return this.userPermissions.indexOf('product_dress_history_live') > -1 },
    canTransfer() { return this.userPermissions.indexOf('product_transfer') > -1 },
    canEdit() { return this.userPermissions.indexOf('product_dress_edit') > -1 },
    canDelete() { return this.userPermissions.indexOf('product_dress_delete') > -1 }
  },
  data() {
    return {
      openDetails: false,
      rowDetails: {},
      OptionsLeader: [],
      searchCondition: { leader_id: null, category_id: null, title: null, unify: null, wares_standard_is: null },
      dataList: [],
      total: 0,
      orderSort: { id: 'desc' },
      pageData: { page_size: 12, current_page: 1 },
      loading: false,
      userColumns: [
        // { hide: false, prop: 'id', label: '序号', width: 80, sortable: false, fixed: false ,type:'index'},
        { hide: true, prop: 'id', label: 'ID', width: 80, sortable: false, fixed: false },
        { hide: false, prop: 'cover_url', label: '产品图', width: 60, sortable: false, fixed: false, type: 'image' },
        { hide: false, prop: 'brand_name', label: '品牌', width: 60, sortable: false, fixed: false },
        { hide: false, prop: 'title', label: '产品', width: 200, sortable: false, fixed: false },
        { hide: false, prop: 'spec_name', label: '尺码/颜色', width: 200, sortable: false, fixed: false },
        { hide: false, prop: 'samples', label: '寄样明细', width: 200, sortable: false, fixed: false },
        { hide: false, prop: 'remark', label: '备注', width: 200, sortable: false, fixed: false },
        { hide: false, prop: 'wares_prep', label: '预售补货', width: 200, sortable: false, fixed: false },
        { hide: false, prop: 'wares_exist', label: '现货库存', width: 200, sortable: false, fixed: false },
        { hide: false, prop: 'delivery_cycle', label: '发货时效', width: 200, sortable: false, fixed: false },
        { hide: false, prop: 'price', label: '日常价', width: 200, sortable: false, fixed: false },
        { hide: false, prop: 'lb_price', label: '直播价', width: 200, sortable: false, fixed: false },
        { hide: false, prop: 'commission', label: '佣金', width: 200, sortable: false, fixed: false },
        { hide: false, prop: 'support_situation', label: '保价情况', width: 200, sortable: false, fixed: false },
        { hide: false, prop: 'leader_name', label: '负责人', width: 200, sortable: false, fixed: false },
        { hide: false, prop: 'updated_at', label: '最后更新时间', width: 200, sortable: false, fixed: false }
      ],
      isColSet: false,
      open: false,
      currentId: null,
      //导入相关
      openImport: false,
      mod: 'Calendar',
      isInitLoading: true,
      downloadLoading: false,
      tableLoading: false,
      customColumnShow: false,
      tableName: 'product_dress',
      joinliveShow: false,
      productId: '',
      HistoricalType: 'kol',
      historicalDialog: false,
      standardOption: [
        { label: '标品', value: 1, color_value: '#D8FCC0' },
        { label: '非标品', value: 2, color_value: '#E9EDFA' }
      ],
      modePrice: 'price',
      price: [],
      searchDialogVisible: false
    }
  },
  created() {
    this.getLeaders()
    this.getList()
    this.getDefaultColumns()
  },
  methods: {
    getLeaders: async function() {
      this.OptionsLeader = await this.$api.productCheckLeaders()
    },
    selectedLeader() {
      this.handleQuery()
    },
    async getList() {
      this.loading = true
      this.currentId = null
      this.dataList = []
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition, this.pageData, { order: this.orderSort })
      const { list, pages } = await this.$api.getProductDressList(searchCondition)
      this.dataList = list || []
      this.pageData.current_page = pages.current_page || 1
      this.pageData.page_size = pages.page_size || 1
      this.total = pages.total
      this.loading = false
      this.isInitLoading = false
      // 同步刷新瀑布流卡片
      if (this.mod === 'Calendar' && this.$refs.dressUpdateCard) {
        this.$refs.dressUpdateCard.refreshList()
      }
    },
    handleQuery() {
      this.pageData.current_page = 1
      this.getList()
    },
    async downExcel() {
      try {
        const searchCondition = this.handleSearchCondition()
        Object.assign(searchCondition, { order: this.orderSort })
        const name = `服饰产品库`
        const response = await this.$api.exportProductDress(searchCondition)

        this.$refs.refExportLink.exportSaveXlsx(response, name)
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
        // alert(JSON.stringify(e))
      }
    },
    handleSearchCondition() {
      let params = { ...{}, ...this.searchCondition }
      params = omitBy(params, (value) => value === undefined || value === null || value === '')
      if (this.price[1] !== undefined && this.price[1] != null) {
        this.price[0] = 0
      }
      this.price = this.price.map((item) => {
        return Number(item)
      })

      params[this.modePrice] = this.price
      return params
    },
    handleDressStore(id) {
      this.$refs.store.show(id)
    },
    handleDelete(row) {
      this.$confirm(`是否确认删除产品【${row.title}】?`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        if (row.id) {
          const id = await this.$api.deleteProductDressInfo(row.id)
          if (id) {
            this.$message.success('删除成功')
            await this.getList()
            if (this.$refs.dressUpdateCard) {
              this.$refs.dressUpdateCard.refreshList()
            }
          }
        }
      }).catch(() => {
        this.msgWarn('取消操作')
      })
    },


    //新增保存按钮
    handelStore(val) {
      this.$refs.addDress.validate().then(() => {
        if (val.cover_url) {
          this.dataList.push(val)
          this.open = false
          this.$message.success('新增成功')
          if (this.$refs.dressUpdateCard) {
            this.$refs.dressUpdateCard.refreshList()
          }
        } else {
          this.$message.error('产品图必填')
        }
      }).catch(() => {
        this.$message.error('请检查必填信息')
      })
    },
    //重置
    reset() {
      this.searchCondition = {}
      this.getList()
    },
    getDefaultColumns() {
      if (localStorage.getItem(`table-column:${this.tableName}`)) {
        const tableSet = JSON.parse(localStorage.getItem(`table-column:${this.tableName}`))
        const userColumn = tableSet.user_columns
        this.columns = [...userColumn]
        this.isColSet = true
      } else {
        this.isColSet = false
        this.columns = [...this.userColumns]
      }
    },
    columnSettingChange(userColumn) {
      this.columns = [...userColumn]
      this.isColSet = true
    },
    // eslint-disable-next-line no-unused-vars
    columnSettingBack() {
      this.customColumnShow = false
      this.isColSet = false
      this.getDefaultColumns()
    },
    // eslint-disable-next-line no-unused-vars
    columnSettingSave() {
      this.customColumnShow = false
      this.isColSet = true
    },
    handleJoinLive(row) {
      this.joinliveShow = true
      this.productId = row.id
    },
    handleAddBtn(type) {
      this.HistoricalType = type
      this.historicalDialog = true
    },
    handleDetails(row) {
      this.rowDetails = row
      this.openDetails = true
    },
    getSelectionProducts: function() {
      return this.$refs.dressTable.getSelection() || []
    },
    callbackProductTransfer: function() {
      this.$refs.dressTable.clearSelection()
      this.handleQuery()
    },
    toHandover: function() {
      const routeUrl = this.$router.resolve({
        name: 'productHandover',
        query: { type: 'dress' }
      })
      window.open(routeUrl.href, '_blank')
    },
    // 搜索确认
    handleSearchConfirm() {
      this.searchDialogVisible = false
      this.handleQuery()
    },
    // 搜索重置
    handleSearchReset() {
      this.searchCondition = {
        leader_id: null,
        category_id: null,
        title: null,
        unify: null,
        wares_standard_is: null
      }
      this.modePrice = 'price'
      this.price = []
      // 重置级联选择器
      if (this.$refs.refProductLeader) {
        this.$refs.refProductLeader.clear()
      }
    },
  }
}
</script>

<style lang='scss' scoped>
@import "@/pages/lb/style/main.scss";

.productDress_main-content {
  .radius_bg {
    margin: 0;
    padding: 0;
  }

  .button-row {
    display: flex;
    flex-wrap: wrap;
    row-gap: 15px;
  }
}

/* 悬浮搜索按钮样式 */
.floating-search-btn {
  position: fixed;
  right: 40px;
  bottom: 120px;
  z-index: 999;

  .search-icon-btn {
    width: 50px;
    height: 50px;
    font-size: 24px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    opacity: 0.6;

    &:hover {
      opacity: 1 !important;
      transform: scale(1.1);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
    }
  }
}
</style>

<style lang='scss'>
@import "@/pages/lb/style/main.scss";

.productDress_main-inner {

  &__content {
    p {
      margin: unset;
    }
  }

  .el-table__cell {
    .cell {
      line-height: 1.2;
    }
  }
}

.dress_content {
  height: 100% !important;

  .radius_bg {
    margin: 0;
    padding: 0;
  }

  .button-toolbar {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 5px;
    row-gap: 15px;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .button-row {
    display: flex;
    flex-wrap: wrap;
    row-gap: 15px;
  }
}

</style>
<style>

.productDress_main-ape .main-content_bg {
  padding: 10px 10px 2px 10px;
}

</style>
